import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';

import { GalleryCarouselImageModel } from 'models';

import { UitkGalleryCarousel, UitkGalleryCarouselProps } from 'uitk-react-gallery-carousel';

import { QueuedImage } from './queued-image';

interface GalleryCarouselProps {
  allyHeadingLevel?: number;
  allyHeadingText: string;
  analytics?: AnalyticsStore;
  carouselName: string;
  currentIndex?: number;
  images: GalleryCarouselImageModel[];
  onImageClick?: () => void;
  onIndexChange?: (index: number) => void;
  onMediaButtonClick: (index: number) => void;
  showGalleryButton?: boolean;
}

export function getQueuedImages(index: number, images: GalleryCarouselImageModel[]) {
  const queuedImages = images.slice(0);

  if (queuedImages && queuedImages.length > 0) {
    if (index - 1 >= 0) {
      queuedImages[index - 1] = { ...queuedImages[index - 1] };
      queuedImages[index - 1].element = <QueuedImage key={`prev1_${queuedImages[index - 1].src}`} src={queuedImages[index - 1].src} />;
    }

    if (index + 1 < queuedImages.length) {
      queuedImages[index + 1] = { ...queuedImages[index + 1] };
      queuedImages[index + 1].element = <QueuedImage key={`next1_${queuedImages[index + 1].src}`} src={queuedImages[index + 1].src} />;
    }

    if (index + 2 < queuedImages.length) {
      queuedImages[index + 2] = { ...queuedImages[index + 2] };
      queuedImages[index + 2].element = <QueuedImage key={`next2_${queuedImages[index + 2].src}`} src={queuedImages[index + 2].src} />;
    }
  }

  return queuedImages;
}

export const GalleryCarousel: React.FunctionComponent<GalleryCarouselProps> = props => {
  const { carouselName, analytics, currentIndex, images } = props;

  const trackingRfrr = `.${carouselName}.GalleryCarousel`;

  const carouselProps: UitkGalleryCarouselProps = {
    ...props,
    analytics: analytics.setupTracker(trackingRfrr, 'Change image in carousel'),
    images: getQueuedImages(currentIndex, images)
  };

  return <UitkGalleryCarousel {...carouselProps} />;
};
